// Simple content for demo
module.exports = {
  items: [
    { label: 'European Union', href: '/example' },
    { label: 'About the European Union', href: '/example' },
    { label: 'News' },
  ],
  label: 'You are here:',
};
